module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dfUYg"))).then(() => module.bundle.root('37nVf'));